// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#gcPayment{gap:24px;font-size:1.1em}#gcPayment>.flex-col{gap:8px;width:100%}#gcPayment>.flex-col>.flex-row{display:grid;grid-template-columns:68% 30%;grid-row:35px;gap:2%}#gcPayment>.flex-col>.flex-row button{padding:0;height:44px}#gcPayment span.gc-sub{color:#717070}#gcValidateField{margin-left:10px}", ""]);
// Exports
module.exports = exports;
